import type { IconSvgObject } from './types';

const TestTubeDiagonalIcon: IconSvgObject = [
  ["path", { d: "M14.5 2.5L21.5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 8.5L8.53553 20.4645C7.87249 21.1275 6.97322 21.5 6.03553 21.5C4.08291 21.5 2.5 19.9171 2.5 17.9645C2.5 17.0268 2.87249 16.1275 3.53553 15.4645L15.5 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.5 12.5H16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TestTubeDiagonalIcon;
